import { $window } from '../common/utils/bom';
import { getQueryString } from '../common/utils/util';
import IUserInfo from '../interface/userInfo';
import { AUTH } from '../common/utils/umuUtil';
import { logOut } from '../dataServices/authDataService';

/**
* 检测完成操作（比如登录）后是否要跳转回之前的页面
*/
export function hasBack() {
    const back = getQueryString('back');
    if (back) {
        $window.location.href = decodeURIComponent(back);
        return true;
    }
    return false;
}

/**
* 进入首页
* @param  {boolen} logined 是否要跳转到登录前的页面
*/
export function toHome(logined) {
    if (!hasBack()) {
        $window.location.href = logined ? '/index' : '/';
    }
}

/**
* 获取用户账号的显示名
* 优先级：电子邮箱 > 手机号 > 用户名 > 微信，否则为空
*/
export function getAccountName(userInfo: IUserInfo) {
    return userInfo.email
        || userInfo.phone
        || userInfo.phone_number
        || userInfo.login_name
        || userInfo.user_name
        || '';
}

export function doLogOut() {
    return logOut().then(function (ret) {
        if (ret.status && ret.data) {
            //通过企业自定义的 url 访问，退出后留在原地
            if (window.location.href.indexOf('eid') > -1) {
                window.location.reload();
            } else {
                window.location.href = '/';
            }
        }
    });
}

/**
 * 从切换账户入口进入登录页面，添加额外参数以记录到账户列表
*/
export function toAddAccount() {
    $window.location.href = AUTH.LOGIN_PAGE + '?switch_account=1';
}


